export default function Marquee({ items, duration = 70, testid = "editorial-marquee" }) {
  return (
    <div data-testid={testid} className="overflow-hidden border-y border-white/10 py-5 select-none bg-black/40">
      <div className="marquee-track flex whitespace-nowrap" style={{ animationDuration: `${duration}s` }}>
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {items.map((t, i) => (
              <span key={i} className="font-sans font-semibold uppercase tracking-[0.35em] text-sm text-zinc-500 px-10 flex items-center gap-10">
                {t}
                <span className="text-nc-orange tracking-normal">//</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
